import dayjs from "dayjs";
import {
  EventStreamContentType,
  fetchEventSource,
} from "@microsoft/fetch-event-source";
import { FlowModuleItemType } from "@packages/flow-core/module";
import { FlowNodeTypeEnum } from "@packages/flow-core/module/node/constants";

export type AskAIType = "TEXT" | "FILE" | "IMAGE" | "VOICE" | "VIDEO";

export type GeneratingStatus = "running" | "done";

type StreamFetchProps = {
  url: string;
  data: Record<string, any>;
  onMessage: (data: StreamResponseDataType) => void;
  onClose: () => void;
  abortCtrl: AbortController;
};
export type StreamResponseDataType = {
  status: GeneratingStatus;
  moduleInfo: FlowModuleItemType & {
    outputMap: Record<string, any>;
    inputMap: Record<string, any>;
  };
  runTime: number;
  beginTime: number;
  endTime: number;
  dialog?: boolean;
};
type StreamResponseType = {
  responseData: StreamResponseDataType[];
};
export const streamFetch = ({
  url,
  data,
  onMessage,
  onClose,
  abortCtrl,
}: StreamFetchProps) => {
  return new Promise<StreamResponseType>((resolve, reject) => {
    (async () => {
      // const timeoutId = setTimeout(() => {
      //   abortCtrl.abort('Time out');
      // }, 300000);

      // response data
      let errMsg = "";
      let responseData: StreamResponseDataType[] = [];
      let finished = false;

      const finish = () => {
        if (errMsg) {
          return failedFinish();
        }
        return resolve({
          responseData,
        });
      };
      const failedFinish = () => {
        finished = true;
        reject({
          message: errMsg || "响应过程出现异常~",
        });
      };

      // animate response to make it looks smooth
      function animateResponseText() {
        if (finished) return;
        // abort message
        if (abortCtrl.signal.aborted) {
          return finish();
        }

        requestAnimationFrame(animateResponseText);
      }
      // start animation
      animateResponseText();

      try {
        // auto complete variables
        const variables = data?.variables || {};
        variables.cTime = dayjs().format("YYYY-MM-DD HH:mm:ss");

        const requestData = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Basic c2FiZXIzOnNhYmVyM19zZWNyZXQ=",
            Accept: "application/json",
          },
          signal: abortCtrl.signal,
          body: JSON.stringify({
            ...data,
          }),
        };

        // send request
        await fetchEventSource(url, {
          ...requestData,
          // headers: {
          //   Authorization: 'Basic c2FiZXIzOnNhYmVyM19zZWNyZXQ=',
          //   'Blade-Auth': `bearer ${Cookies.get('xuanfeng-token')!}`,
          // },
          async onopen(res) {
            // clearTimeout(timeoutId);
            const contentType = res.headers.get("content-type");

            // not stream
            if (contentType?.startsWith("text/plain")) {
              return failedFinish();
            }

            // failed stream
            if (
              !res.ok ||
              !res.headers
                .get("content-type")
                ?.startsWith(EventStreamContentType) ||
              res.status !== 200
            ) {
              try {
                const rsp = (await res.json()) as API.BaseResponse<void>;
                errMsg = rsp.msg;
                failedFinish();
              } catch (err) {
                const errText = await res.clone().text();
                if (!errText.startsWith("event: error")) {
                  failedFinish();
                }
              }
              abortCtrl.abort();
            }
          },
          onmessage({ data }) {
            const parseJson: StreamResponseDataType = (() => {
              try {
                return JSON.parse(data);
              } catch (error) {
                return {};
              }
            })();
            responseData.push(parseJson);
            onMessage(parseJson);
            if (
              parseJson.status === "done" &&
              parseJson.moduleInfo.flowType !== FlowNodeTypeEnum.globalVariable
            ) {
              finished = true;
              finish();
              // 结束连接，避免 SSE 异常后 fetch-event-source 用原请求体自动重试
              abortCtrl.abort();
              return;
            }
          },
          onclose() {
            finished = true;
            onClose();
          },
          onerror(err) {
            // 必须 throw，否则 @microsoft/fetch-event-source 会约 1s 自动重试同一请求
            abortCtrl.signal.throwIfAborted();
            failedFinish();
            throw err instanceof Error ? err : new Error("Stop retry!");
          },
          openWhenHidden: true,
        });
      } catch (err: any) {
        // clearTimeout(timeoutId);

        if (abortCtrl.signal.aborted) {
          finished = true;
          return;
        }
        console.log(err, "fetch error");

        failedFinish();
      }
    })();
  });
};
